"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var textFormatUtils_1 = require("./textFormatUtils");
exports.Format = textFormatUtils_1.Format;
exports.textFormatter = textFormatUtils_1.textFormatter;
//# sourceMappingURL=index.js.map